export default {
  "adsUserPushRecord.loadingFailedRecords": "正在获取失败记录…",
  "adsUserPushRecord.noFailedRecordsToRetry": "目前没有失败的记录需要重推",
  'adsUserPushRecord.title': '推送记录',
  'adsUserPushRecord.memberId': '会员ID',
  'adsUserPushRecord.memberAccount': '会员账号',
  'adsUserPushRecord.adsName': '归因名称',
  'adsUserPushRecord.agentAccount': '代理账号',
  'adsUserPushRecord.adsType': '归因平台',
  'adsUserPushRecord.status': '状态',
  'adsUserPushRecord.eventName': '归因事件',
  'adsUserPushRecord.dateRange': '日期范围',
  'adsUserPushRecord.search': '查询',
  'adsUserPushRecord.reset': '重置',
  'adsUserPushRecord.userId': '用户ID',
  'adsUserPushRecord.userName': '用户名',
  'adsUserPushRecord.agentName': '代理名称',
  'adsUserPushRecord.pushTime': '推送时间',
  'adsUserPushRecord.action': '操作',
  'adsUserPushRecord.viewParams': '查看参数',
  'adsUserPushRecord.retry': '重新推送',
  'adsUserPushRecord.batchRetryButtonText': '批量重推失败记录 (共{count}条)',
  'adsUserPushRecord.paramDetail': '参数详情',
  'adsUserPushRecord.paramDisclaimer': '*本页面参数仅供参考，具体以归因方对接文档为准*',
  'adsUserPushRecord.batchRetryTitle': '批量重新推送',
  'adsUserPushRecord.batchRetryConfirm': '本次批量推送以下失败记录：',
  'adsUserPushRecord.batchRetryItem': '• 会员账号：{account}，事件：{event}，推送时间：{time}',
  'adsUserPushRecord.batchRetryWarning': '请确认批量推送，操作不可撤销。',
  'adsUserPushRecord.confirm': '确认',
  'adsUserPushRecord.cancel': '取消',
  'adsUserPushRecord.retrySuccess': '重新推送成功',
  'adsUserPushRecord.retryFailed': '重新推送失败',
  'adsUserPushRecord.batchRetrySuccess': '批量重推成功',
  'adsUserPushRecord.fetchDataFailed': '获取数据失败',
  'adsUserPushRecord.fetchAgentsFailed': '获取代理列表失败',
  'adsUserPushRecord.batchRetryFailed': '批量重推失败',
  'adsUserPushRecord.fetchFailedRecordsFailed': '获取失败记录失败',
  'adsUserPushRecord.pagination': '第 {current} 页，共 {page} 页，总计 {total} 条记录',
  'adsUserPushRecord.noData': '暂无数据',
};
